import React from 'react';

function Divider({ type, height = 100 , backClass = 'text-soft-primary'}) {
    return (
        <section className="wrapper bg-light mt-10">
            <div className="overflow-hidden">
                <div className={`divider ${type === 'Footer' ? 'text-navy' : backClass}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 1440 ${height}`}>
                        <path fill="currentColor"
                            d="M1260,1.65c-60-5.07-119.82,2.47-179.83,10.13s-120,11.48-180,9.57-120-7.66-180-6.42c-60,1.63-120,11.21-180,16a1129.52,1129.52,0,0,1-180,0c-60-4.78-120-14.36-180-19.14S60,7,30,7H0v93H1440V30.89C1380.07,23.2,1319.93,6.15,1260,1.65Z" />
                    </svg>
                </div>
            </div>
        </section>
    );
}


export default Divider;
